module.exports = __webpack_public_path__ + "static/media/Southgrove Kitchen sink-Dishwasher.f18f6199.JPG";